module.exports = __webpack_public_path__ + "img/logo.ddf19d55.png";